import { createTheme } from '@mui/material'
import type {} from '@mui/x-date-pickers/themeAugmentation'
import {
  avatarTheme,
  breadcrumbsTheme,
  buttonTheme,
  cssbaseline,
  colors,
  popoverTheme,
  inputBaseTheme,
  inputLabelTheme,
  outlinedInputTheme,
  chipTheme,
  tableTheme,
  tableCellTheme,
  tableContainerTheme,
  tableRowTheme,
  tooltipTheme,
  typographyTheme,
  dialogTitleTheme,
  dialogActionsTheme,
  iconButtonTheme,
  tabTheme,
  tabsTheme,
  svgIconTheme,
} from './theme/index.theme'

const theme = createTheme({
  typography: {
    fontFamily: 'Open Sans',
  },
  palette: {
    mode: 'dark',
    primary: {
      main: colors.primary,
    },
    background: {
      default: colors.nav,
      paper: colors.paper2,
    },
    text: {
      primary: colors.white,
    },
  },
  components: {
    MuiAvatar: {
      styleOverrides: avatarTheme,
    },
    MuiBreadcrumbs: {
      styleOverrides: breadcrumbsTheme,
    },
    MuiButton: {
      styleOverrides: buttonTheme,
    },
    MuiChip: {
      styleOverrides: chipTheme,
    },
    MuiCircularProgress: {
      styleOverrides: {
        colorPrimary: {
          color: colors.primary,
        },
      },
    },
    MuiCssBaseline: {
      styleOverrides: cssbaseline,
    },
    MuiDialogTitle: {
      styleOverrides: dialogTitleTheme,
    },
    MuiDialogActions: {
      styleOverrides: dialogActionsTheme,
    },
    MuiIconButton: {
      styleOverrides: iconButtonTheme,
    },
    MuiInputBase: {
      styleOverrides: inputBaseTheme,
    },
    MuiInputLabel: {
      styleOverrides: inputLabelTheme,
    },
    MuiListItemText: {
      styleOverrides: {
        primary: {
          fontSize: 14,
        },
      },
    },
    MuiOutlinedInput: {
      styleOverrides: outlinedInputTheme,
    },
    MuiPaper: {
      styleOverrides: {
        root: {
          backgroundImage: 'none',
        },
      },
    },
    MuiPopover: {
      styleOverrides: popoverTheme,
    },
    MuiSvgIcon: {
      styleOverrides: svgIconTheme,
    },
    MuiTab: {
      styleOverrides: tabTheme,
    },
    MuiTabs: {
      styleOverrides: tabsTheme,
    },
    MuiTable: {
      styleOverrides: tableTheme,
    },
    MuiTableCell: {
      styleOverrides: tableCellTheme,
    },
    MuiTableContainer: {
      styleOverrides: tableContainerTheme,
    },
    MuiTableRow: {
      styleOverrides: tableRowTheme,
    },
    MuiTooltip: {
      styleOverrides: tooltipTheme,
    },
    MuiTypography: {
      styleOverrides: typographyTheme,
    },
  },
})

export default theme
